import { ProcesoService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const ProcesoManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return ProcesoService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };
  const procesoAutomaticos = () => {
    return ProcesoService.procesoAutomaticos().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const ejecutarProceso = (args) => {
    return ProcesoService.ejecutarProceso(args).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  return {
    listado,
    procesoAutomaticos,
    ejecutarProceso
  };
})();
